<template>
  <div style="height:100%;">
    <div id="loadingDiv"  v-if="isLoadingDiv"><span><spinner size="small"></spinner></span><span>Loading...</span></div>
    <b-container class="base-container">
      <topbar :isLoading="isLoading"></topbar>
      <div class="app-main-container">
        <sidebar :isLoading="isLoading"></sidebar>
        <div class="stage" id="stage">
        <div class="site-toggle-wrapper" v-if="showSiteLists">
            <b-button  @click="emitShowSiteLists" v-b-tooltip.hover title="Show site lists" align="" class="site-toggle" ><right-arrow-icon class="arrow"></right-arrow-icon></b-button>
        </div>
          <iwpnavbar :isLoading="isLoading"></iwpnavbar>
          <router-view class="stage-content" v-if="!isLoading"></router-view>
          <div class="stage-loading-wrapper" v-if="isLoading">
            <div class="main-loading-logo logo">
              <logo class="logo-svg"></logo>
            </div>
            <div class="main-loading-title">
              Admin Panel v{{appVersion}}
            </div>
            <div class="main-loading-progress">
              <b-progress :value="value" :max="max" class="custom"></b-progress>
            </div>
          </div>
          <div class="app-footer"  v-if="!isLoading"> 
            <processqueue v-if="!isLoading"></processqueue>
          </div>
        </div>
      </div>
    </b-container>
    <notifications group="foo" class="top-notification">
      <template slot="body" slot-scope="props">
        <div class="notification-item " v-bind:class="props.item.type">
          <a class="notification-title">
            <success-icon class="icon-default success" v-if="props.item.type==='N'"></success-icon>
            <error-icon class="icon-default error" v-if="props.item.type==='E'"></error-icon>
            <warning-icon class="icon-default warning" v-if="props.item.type==='W'"></warning-icon>
            <span>{{props.item.title}}</span>
          </a>
          <a class="close" @click="props.close">
            <close-icon class="icon-default close" v-bind:class="props.item.type"></close-icon>
          </a>
          <div class="notification-content" v-html="props.item.text">
          </div>
        </div>
      </template>
    </notifications>
    <notifications group="task" position="bottom right" class="bottom-notification">
      <template slot="body" slot-scope="props">
        <div class="notification-item " v-bind:class="props.item.type">
          <a class="notification-title">
            <success-icon class="icon-default success" v-if="props.item.type==='N'"></success-icon>
            <error-icon class="icon-default error" v-if="props.item.type==='E'"></error-icon>
            <warning-icon class="icon-default warning" v-if="props.item.type==='W'"></warning-icon>
            <span>{{props.item.title}}</span>
          </a>
          <a class="close" @click="props.close">
            <close-icon class="icon-default close" v-bind:class="props.item.type"></close-icon>
          </a>
          <div v-if="props.item.text" class="notification-content" v-html="props.item.text">
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import logo from '../assets/logo.svg';
import CloseIcon from '../assets/close.svg';
import SuccessIcon from '../assets/success.svg';
import ErrorIcon from '../assets/error.svg';
import WarningIcon from '../assets/warning.svg';
import RightArrowIcon from '../assets/rightarrow2.svg';

import Vue from 'vue';
import routes from '../router/routes';
import _ from 'lodash';
import Utils from '../mixins/utils';
import { EventBus } from '../event/event-bus.js';
export default {
  name: 'home',
  components: {
    CloseIcon,
    SuccessIcon,
    ErrorIcon,
    WarningIcon,
    logo,
    RightArrowIcon
  },
  mixins: [Utils],
  data() {
    return {
      routes: routes[0].children,
      isLoading: true,
      max: 100,
      showSiteLists:false,
      value: 33.333333333,
      appVersion: window.appVersion,
      isLoadingDiv: false,
    };
  },
  mounted() {
    // this.$notify({
    //   group: "foo",
    //   title: "Important message",
    //   type: "N",
    //   text: "Hello user! This is a notification!",
    //   duration: -1
    // });
    // this.$notify({
    //   group: "foo",
    //   title: "Important message",
    //   type: "W",
    //   text: "Hello user! This is a notification!",
    //   duration: -1
    // });
    // this.$notify({
    //   group: "foo",
    //   title: "Important message",
    //   type: "E",
    //   text: "Hello user! This is a notification!",
    //   duration: -1
    // });
    EventBus.$on('hide-site-lists', value => {
      this.showSiteLists = value;
    });
    EventBus.$on('show-ajax-loading', value => {
      this.isLoadingDiv = value;
    });
  },
  created() {
    this.value = 0;
    this.$store
      .dispatch({
        type: 'getInit'
      })
      .then(() => {
        this.value = 50;
        let payload = {};
        payload.requiredData = {
          getInstalledAddonsV3: 1
        };
        payload.stopAjaxLoading= true;
        this.$store.dispatch('sendAction', payload).then(response => {
          this.$store.commit(
            'SET_INSTALLED_ADDONS',
            response.data.getInstalledAddonsV3
          );
          /* Right now we are not using any dynamic store registration on addons 
          let addons = response.data.getInstalledAddonsV3;
          _.each(addons, slug => {
            this.loadAddon(slug).then(module => {
              if (module && module.default && module.default.Store) {
                this.$store.registerModule(slug, module.default.Store);
              }

              // return module.default.Component;
            });
          });*/
          this.value = 100;
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        });
      })
      .catch(err => {
        
      });

    window.eventHub.$on('sendNotification', event => {
      this.processNotification(event.notifications);
    });
    window.eventHub.$on('sendTaskNotification', event => {
      this.processTaskNotification(event.notifications);
    });
    window.eventHub.$on('fireQueue', event => {
      this.processFireQueue(event.fireQueue);
    });
  },
  methods: {
    processNotification(notifications) {
      _.each(notifications, notification => {
        this.$notify({
          group: 'foo',
          title: notification.title,
          type: notification.type,
          text: notification.message,
          duration: -1
        });
      });
    },
    processFireQueue(data){
      if(data && data.getSitesV3){
        this.$store.commit(
            'SET_SITES',
            data.getSitesV3
          );
      }
    },
    emitShowSiteLists(){
      this.showSiteLists = false;
      EventBus.$emit('show-site-lists', false);
    },
    processTaskNotification(notifications) {
      let title = '';
      let type = 'N';
      let message = '';
      if (notifications.title) {
        title = notifications.title;
        if (notifications.status == 'error') {
          type = 'E';
        }
      }
      if (title) {
          this.$notify({
            group: 'task',
            title: title,
            type: type,
            text: message,
            duration: 3000
          });
      }
    },
  }
};
</script>

<style scoped lang="scss">
</style>
